// @flow
import * as React from 'react';
import classNames from 'classnames';

import './VehicleImageWithPlaceholder.scss';

type State = {
  imageLoadFinishedClass: string,
  placeholderStyle: Object
};

type Props = {
  src: string,
  mask?: boolean,
  className?: string
};

class VehicleImageWithPlaceholder extends React.Component<Props, State> {
  static block = 'vehicle-image';

  state = {
    imageLoadFinishedClass: '',
    placeholderStyle: {
      backgroundImage: `url(${require('./loading_car.svg')})`
    }
  };

  onLoad = () => {
    const ns = VehicleImageWithPlaceholder.block;

    this.setState({
      imageLoadFinishedClass: `${ns}__image--fade-in`,
      placeholderStyle: { background: 'none' }
    });
  };

  render() {
    const { placeholderStyle, imageLoadFinishedClass } = this.state;
    const { src, className, mask } = this.props;
    const ns = VehicleImageWithPlaceholder.block;
    const rootClassName = classNames(ns, className);
    return (
      <div className={rootClassName}>
        <div className={`${ns}__placeholder`} style={placeholderStyle}>
          <img
            className={`${ns}__image ${imageLoadFinishedClass}`}
            src={src}
            alt=""
            onLoad={this.onLoad}
          />
        </div>
        {mask && <div className={`${ns}__mask`} />}
      </div>
    );
  }
}

export default VehicleImageWithPlaceholder;



// WEBPACK FOOTER //
// ./src/components/atoms/VehicleImageWithPlaceholder/VehicleImageWithPlaceholder.js